import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard,
  FileText,
  Calendar,
  Users,
  PenLine,
  Edit,
  Image as ImageIcon,
  Settings,
  Globe,
  Database,
  User,
  Home,
  LogOut,
  BarChart3,
} from 'lucide-react';

const Sidebar = ({ open, setOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  
  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/analytics', label: 'Analytics', icon: BarChart3 },
    { path: '/admin/constitution', label: 'Constitution', icon: FileText },
    { path: '/admin/signatures', label: 'Signatures', icon: PenLine },
    { path: '/admin/activities', label: 'Activities', icon: Calendar },
    { path: '/admin/associations', label: 'Associations', icon: Users },
    { path: '/manage-associations', label: 'Content Portal', icon: Edit },
    { path: '/admin/media', label: 'Media Library', icon: ImageIcon },
    { path: '/admin/site-settings', label: 'Site Settings', icon: Settings },
    { path: '/admin/seo-settings', label: 'SEO / OG Settings', icon: Globe },
    { path: '/admin/data-management', label: 'Data Management', icon: Database },
    { path: '/admin/profile', label: 'My Profile', icon: User },
  ];
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <>
      {open && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}
      
      <aside className={`fixed left-0 top-0 h-full w-64 bg-slate-900 border-r border-slate-800 z-50 transform transition-transform duration-300 lg:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="flex flex-col h-full">
          <div className="p-6 border-b border-slate-800">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cameroon-green via-cameroon-red to-cameroon-yellow flex items-center justify-center">
                <span className="text-white font-serif font-bold text-lg">C</span>
              </div>
              <div>
                <span className="font-serif font-bold text-white">CCA Admin</span>
                <p className="text-xs text-slate-400">Management Portal</p>
              </div>
            </Link>
          </div>
          
          <nav className="flex-1 p-4 overflow-y-auto">
            <ul className="space-y-1">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={() => setOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                      isActive(item.path)
                        ? 'bg-cameroon-green text-white'
                        : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                    }`}
                  >
                    <item.icon className="w-5 h-5" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          
          <div className="p-4 border-t border-slate-800">
            <Link
              to="/"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white transition-colors"
            >
              <Home className="w-5 h-5" />
              Back to Site
            </Link>
            <button
              onClick={() => { logout(); navigate('/'); }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-slate-400 hover:bg-red-900/20 hover:text-red-400 transition-colors"
            >
              <LogOut className="w-5 h-5" />
              Logout
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
